import { AvailableDataSource } from '../types/appointments/ConsultWorkflowTypes';

export const WORKFLOW_DATA_SOURCES: AvailableDataSource[] = [
	{
		identifier: 'health_assessment',
		source_type: 'questionnaire',
		name: 'Questionnaire Data',
		variable_name: 'questionnaireData',
		description: 'Patient health assessment questionnaire responses covering lifestyle, symptoms, and personal health goals.',
		is_required: true,
	},
	{
		identifier: 'core_panels',
		source_type: 'genetic_panel',
		name: 'Genetic Panel Summaries',
		variable_name: 'panelSummaries',
		description: 'Summarised genetic panel results highlighting key findings across all tested gene variants.',
		is_required: true,
	},
	{
		identifier: 'structured_genetics',
		source_type: 'genetic_panel',
		name: 'Structured Genetic Data',
		variable_name: 'structuredGeneticsJson',
		description: 'Full structured JSON representation of all genetic variant results for detailed analysis.',
		is_required: true,
	},
	{
		identifier: 'diet_scores',
		source_type: 'diet_scores',
		name: 'Diet Compatibility Scores',
		variable_name: 'dietScores',
		description: 'Genetically-derived compatibility scores for various diet types and nutritional approaches.',
		is_required: true,
	},
	{
		identifier: 'exercise_scores',
		source_type: 'exercise_scores',
		name: 'Exercise Aptitude Scores',
		variable_name: 'exerciseScores',
		description: 'Genetically-derived aptitude scores for different exercise modalities and training intensities.',
		is_required: true,
	},
	{
		identifier: 'blood_results',
		source_type: 'blood_results',
		name: 'Blood Test Results',
		variable_name: 'bloodResults',
		description: 'Recent blood test results including full blood count, metabolic panels, and other haematology markers.',
		is_required: false,
	},
	{
		identifier: 'lab_results_comprehensive',
		source_type: 'lab_results',
		name: 'Laboratory Test Results',
		variable_name: 'labResults',
		description: 'Comprehensive laboratory test results covering pathology, hormones, and specialist diagnostics.',
		is_required: false,
	},
	{
		identifier: 'medical_history_records',
		source_type: 'medical_history',
		name: 'Medical History Records',
		variable_name: 'medicalHistory',
		description: 'Active medical history including diagnoses, chronic conditions, past surgeries, and significant health events.',
		is_required: false,
	},
	{
		identifier: 'current_medications',
		source_type: 'medications',
		name: 'Current Medications',
		variable_name: 'medications',
		description: 'List of current medications including dosage, frequency, and the prescribing practitioner.',
		is_required: false,
	},
	{
		identifier: 'vital_signs',
		source_type: 'vital_signs',
		name: 'Vital Signs & Measurements',
		variable_name: 'vitalSigns',
		description: 'Patient vital signs including blood pressure, heart rate, weight, height, and other clinical measurements.',
		is_required: false,
	},
	{
		identifier: 'referrals',
		source_type: 'referrals',
		name: 'Specialist Referrals',
		variable_name: 'referrals',
		description: 'Specialist referral records including the referring practitioner, specialist type, urgency, and current status.',
		is_required: false,
	},
	{
		identifier: 'supplement_regimens',
		source_type: 'supplement_regimens',
		name: 'Active Supplement Regimens',
		variable_name: 'supplementRegimens',
		description: 'Currently active supplement regimens with itemised products, dosages, timing, and clinical rationale.',
		is_required: false,
	},
	{
		identifier: 'appointments',
		source_type: 'appointments',
		name: 'Appointment History',
		variable_name: 'appointmentHistory',
		description: 'Recent appointment history including appointment type, date, status, and clinical notes.',
		is_required: false,
	},
];

export const COMPREHENSIVE_DATA_SOURCE_OPTIONS = [
	{ value: 'genetic_panel',       label: 'Genetic Panel' },
	{ value: 'questionnaire',       label: 'Questionnaire' },
	{ value: 'medical_history',     label: 'Medical History' },
	{ value: 'medications',         label: 'Medications' },
	{ value: 'lab_results',         label: 'Lab Results' },
	{ value: 'blood_results',       label: 'Blood Results' },
	{ value: 'diet_scores',         label: 'Diet Scores' },
	{ value: 'exercise_scores',     label: 'Exercise Scores' },
	{ value: 'vital_signs',         label: 'Vital Signs' },
	{ value: 'referrals',           label: 'Referrals' },
	{ value: 'supplement_regimens', label: 'Supplement Regimens' },
	{ value: 'appointments',        label: 'Appointment History' },
] as const;
